export const deletePost = async (postId) => {
    // console.log("Sending postId to backend:", postId); // Debugging: log postId before sending

    try {
        const response = await fetch('https://blog-swipe-backend.vercel.app/deleteBlogPost', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ postId}), // Send JSON object with postId
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to delete post');
        }

        const result = await response.json();
        console.log(result);
        return result; // Return response data
    } catch (error) {
        console.error('Error deleting post:', error);
        throw error;
    }
};
